import { setUserConsents } from '../user/user.actions';
import { setAllCookies } from './gdprNotice.utils';
import { sendEvent } from '../analytics/analytics.utils';

export const TOGGLE_GDPR_NOTICE = 'gdpr/TOGGLE_GDPR_NOTICE';

export const PRESS_GDPR_NOTICE_OK_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_OK_BUTTON';

export const PRESS_GDPR_NOTICE_DECLINE_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_DECLINE_BUTTON';

export const PRESS_GDPR_NOTICE_PARAMETERS_BUTTON = 'gdpr/PRESS_GDPR_NOTICE_PARAMETERS_BUTTON';

export const toggleGdprNotice = () => ({ type: TOGGLE_GDPR_NOTICE });

const getConsentNames = consents => Object.keys(consents).filter(key => consents[key].consent);

const handleGdprButtonPress = consents => dispatch => {
  dispatch(setUserConsents(consents));
  dispatch(toggleGdprNotice());
};

export const pressGdprNoticeDeclineAllButton = () => dispatch => {
  const consents = setAllCookies(false);
  dispatch(handleGdprButtonPress(consents));
  sendEvent({
    key: 'gdprRefuse',
    consentNames: getConsentNames(consents),
  });
};

export const pressGdprNoticeConsentAllButton = () => dispatch => {
  const consents = setAllCookies(true);
  sendEvent({ key: 'pressCookieBannerConsentButton' });
  dispatch(handleGdprButtonPress(consents));
  sendEvent({
    key: 'gdprAccept',
    consentNames: getConsentNames(consents),
  });
};
